import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import Edit from './assets/edit.svg';
import Exit from './assets/exit.svg';
import CheckMark2 from './assets/checkMark2.svg';
import Trash from './assets/trash.svg';

import { selectConversationId } from './preferences/preferenceSlice';

export default function ConversationTile({ conversation, selectConversation, onDeleteConversation, onSave }) {
    const conversationId = useSelector(selectConversationId);
    const tileRef = useRef(null);

    const [isEdit, setIsEdit] = useState(false);
    const [conversationName, setConversationsName] = useState('');
    // useOutsideAlerter(
    //   tileRef,
    //   () =>
    //     handleSaveConversation({
    //       id: conversationId || conversation.id,
    //       name: conversationName,
    //     }),
    //   [conversationName],
    // );

    useEffect(() => {
        setConversationsName(conversation.name);
    }, [conversation.name]);

    function handleEditConversation() {
        setIsEdit(true);
    }

    function handleSaveConversation(changedConversation) {
        if (changedConversation.name.trim().length) {
            onSave(changedConversation);
            setIsEdit(false);
        } else {
            onClear();
        }
    }

    function onClear() {
        setConversationsName(conversation.name);
        setIsEdit(false);
    }
    const isActive = conversationId === conversation.id;
    return (
        <div
            ref={tileRef}
            onClick={() => {
                selectConversation(conversation.id);
            }}
            className={`px-4 py-6 my-auto mt-1 flex h-9 cursor-pointer items-center justify-between gap-4 rounded-xl hover:bg-gray-100 ${
                isActive ? 'bg-gray-100' : ''
            }`}
            style={{
                borderLeft: isActive ? '3px solid var(--mui-palette-primary-main, #0d9488)' : '3px solid transparent'
            }}
        >
            <div className={`flex min-w-0 flex-1 items-center gap-2 ${conversationId === conversation.id ? 'w-[75%]' : 'w-[95%]'}`}>
                <div
                    className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#1976D2] text-xs font-semibold text-white"
                    title="Cuộc hội thoại của bạn"
                >
                    Bạn
                </div>
                {isEdit ? (
                    <input
                        autoFocus
                        type="text"
                        className="h-6 min-w-0 flex-1 px-1 text-sm font-normal leading-6 outline-[#0075FF] focus:outline-1"
                        value={conversationName}
                        onChange={(e) => setConversationsName(e.target.value)}
                    />
                ) : (
                    <p className="min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-sm font-normal leading-6 text-gray-800">
                        {conversationName}
                    </p>
                )}
            </div>
            {conversationId === conversation.id && (
                <div className="flex">
                    <img
                        src={isEdit ? CheckMark2 : Edit}
                        alt="Edit"
                        className="mr-3 h-4 w-4 cursor-pointer hover:opacity-50"
                        id={`img-${conversation.id}`}
                        onClick={(event) => {
                            event.stopPropagation();
                            isEdit
                                ? handleSaveConversation({
                                      id: conversationId,
                                      name: conversationName
                                  })
                                : handleEditConversation();
                        }}
                    />
                    <img
                        src={isEdit ? Exit : Trash}
                        alt="Exit"
                        className={`mr-4 ${isEdit ? 'h-3 w-3' : 'h-4 w-4'}mt-px  cursor-pointer hover:opacity-50`}
                        id={`img-${conversation.id}`}
                        onClick={(event) => {
                            event.stopPropagation();
                            isEdit ? onClear() : onDeleteConversation(conversation.id);
                        }}
                    />
                </div>
            )}
        </div>
    );
}
